import { render, staticRenderFns } from "./cross_links.vue?vue&type=template&id=e97a048a&scoped=true"
import script from "./cross_links.vue?vue&type=script&lang=js"
export * from "./cross_links.vue?vue&type=script&lang=js"
import style0 from "./cross_links.vue?vue&type=style&index=0&id=e97a048a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97a048a",
  null
  
)

export default component.exports